import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { noTechnicalKnowledgeRequired } from '../../assets/data/features/no-technical-knowledge-required';

export const Route = createFileRoute('/_marketing/no-technical-knowledge-required')({
  component: () => <FeatureArticle data={noTechnicalKnowledgeRequired} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(noTechnicalKnowledgeRequired),
  }),
  head: basicHead,
});
